import { JMS_KEYS } from '@/config/jmsStorage';

function generate(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return template.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceSignature(): string {
  try {
    const stored = localStorage.getItem(JMS_KEYS.deviceSignature)?.trim();
    if (stored) {
      return stored;
    }
    const value = generate();
    localStorage.setItem(JMS_KEYS.deviceSignature, value);
    return value;
  } catch {
    return generate();
  }
}
